import { AccountingAccountCreateRequestDto } from "@/models/interface/accounting-account";
import { initForm } from "@/store/resources/AccountingAccount.resource";

export type FormValue = AccountingAccountCreateRequestDto & {
  accountTypeName: string;
  currencyName: string;
  parentName: string;
};
export type State = {
  form: FormValue;
};

const state: State = {
  form: initForm(),
};

const mutations = {
  setForm: (st: State, payload: FormValue): void => {
    const copy = { ...st.form };
    st.form = {
      ...copy,
      ...payload,
    };
  },
};

const getters = {
  getForm: (st: State): FormValue => {
    return st.form;
  },
};

const actions = {
  resetStore: ({ commit }): void => {
    const form = initForm();
    commit("setForm", form);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
